import { DateOfBirth } from 'app/components/Placement/PlacementDetails/Edit/Components/DateOfBirth';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectEditableRequirementTypes } from '../../../../../../../../../store/redux-store/placement-summary/selectors';
import { TransportationRow } from './TransportationTable';
import { useArrivedFieldsetMeta } from '../useArrivedFieldsetMeta';
import { CustomTooltip } from '@AMIEWEB/Common';

export const TransportationDateOfBirth = () => {
  const { t } = useTranslation();
  const { dob } = useSelector(selectEditableRequirementTypes);
  const fieldsetMeta = useArrivedFieldsetMeta();

  return (
    <TransportationRow
      id="placement-offer-transportation-dob"
      label={t('placement.profile.summary.offer.transportation.dateOfBirth')}
      controlComponent={
        <CustomTooltip disabled={!fieldsetMeta.disabled} tooltipContent={fieldsetMeta.title} placement="bottom-start" arrow={false} isStandardContent>
          <DateOfBirth disabled={fieldsetMeta.disabled} />
        </CustomTooltip>
      }
      requirement={dob?.requirement}
    />
  );
};
